var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4964 13.6577C12.8717 14.1503 11.9097 14.106 11.3475 13.5587L7.00069 9.32688L2.65241 13.5587C2.09015 14.1059 1.12815 14.1502 0.503531 13.6577C-0.120908 13.165 -0.171499 12.3221 0.390589 11.7748L5.86829 6.44141C6.15688 6.16046 6.56929 6 7.00069 6C7.43187 6.00015 7.84314 6.16059 8.1316 6.44141L13.6093 11.7748C14.1715 12.3222 14.121 13.165 13.4964 13.6577Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.503636 0.342325C1.1283 -0.150273 2.09028 -0.106002 2.65251 0.441286L6.99931 4.67313L11.3476 0.441287C11.9098 -0.105878 12.8719 -0.150232 13.4965 0.342328C14.1209 0.834958 14.1715 1.67789 13.6094 2.22517L8.1317 7.55859C7.84312 7.83955 7.4307 8 6.99931 8C6.56813 7.99986 6.15685 7.83942 5.8684 7.55859L0.390694 2.22517C-0.171506 1.67784 -0.12098 0.834954 0.503636 0.342325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.5672feae2d877d051c3ffc1af1f237d2.svg";
export { ForwardRef as ReactComponent };